import React, { useState, useEffect } from "react";
import logo from "../assets/newlogo1.png";
import { HiOutlineMenu } from "react-icons/hi";
import { BiX } from "react-icons/bi";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import { useLocation } from "react-router-dom";

function Header({selectedTool , setSelectedTool}) {
  const location = useLocation();
  const currentPath = location.pathname;

  const [userName, setUserName] = useState("");
  useEffect(() => {
    // Retrieve momInfo from localStorage
    const storedMomInfo = localStorage.getItem("momInfo");
    if (storedMomInfo) {
      const parsedMomInfo = JSON.parse(storedMomInfo);
      setUserName(parsedMomInfo.name || "Login / Signup");
    } else {
      setUserName("Login / Signup");
    }
  }, []);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();


  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleLinkClick = (tool) => {
    setSelectedTool(tool);
    
  };

  const resetToolSelection = () => {
    setSelectedTool("");
  };

  return (
    <>
      {/* Header Section */}
      <nav
        className="navbar navbar-expand-lg navbar-light bg-body heade w-100"
        style={{
          backgroundColor: "white",
          position: "sticky ",
          top: "0px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.21)",
        }}
      >
        <div className="container">
          <a className="navbar-brand" href="/">
            <img src={logo} alt="Logo" />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleSidebar}
            aria-expanded={sidebarOpen}
            aria-label="Toggle Sidebar"
          >
            <HiOutlineMenu size={30} />
          </button>

          {/* Navbar Links */}
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  aria-current="page"
                  to="/"
                  onClick={resetToolSelection}
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  to="/blogs"
                  onClick={resetToolSelection}
                >
                  Blogs
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  to="/help-support"
                  onClick={resetToolSelection}
                >
                  Help & Support
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                  to="/faqs"
                  onClick={resetToolSelection}
                >
                  FAQ's
                </NavLink>
              </li>

              <li
                className="nav-item dropdown"
                onMouseEnter={() => setDropdownOpen(true)}
                onMouseLeave={() => setDropdownOpen(false)}
              >
                <NavLink
                  className={({ isActive }) =>
                    isActive || selectedTool
                      ? "nav-link dropdown-toggle active"
                      : "nav-link dropdown-toggle"
                  }
                  style={({ isActive }) => ({
                    fontWeight: isActive  || selectedTool ? "bold" : "normal",
                  })}
                  to="/tools"
                  role="button"
                  aria-expanded={dropdownOpen}
                >
                  Tools
                </NavLink>
                <ul
                  className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    right: "0",
                    zIndex: 1050,
                    width: "auto",
                    minWidth: "250px",
                    background: "white",
                  }}
                >
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/dos-donts"
                      onClick={() => handleLinkClick("dos")}
                    >
                      Dos and Don'ts
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/kick-timer"
                      onClick={() => handleLinkClick("kicker")}
                    >
                      Kick Timer
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/contraction"
                      onClick={() => handleLinkClick("contraction")}
                    >
                      Contraction Timer
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/checklist"
                      onClick={() => handleLinkClick("checklist")}
                    >
                      Trimester Checklist
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/videos"
                      onClick={() => handleLinkClick("videos")}
                    >
                      Videos
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>

            {/* Login/Signup */}
            <div className="d-flex logins ">
              <Link to="/login" style={{ color: "black" }}>
                <button className="btn  login">
                  <FaUser
                    style={{
                      marginRight: "8px",
                      fontSize: "19px",
                      marginTop: "-5px",
                    }}
                  />{" "}
                  {/* Login / Signup */}
                  {userName}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar Section */}
      <div
        id="sidebars"
        className={`sidebar ${sidebarOpen ? "show" : ""}`}
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          right: sidebarOpen ? 0 : "-250px",
          height: "100%",
          backgroundColor: "#B24C76",
          width: "250px",
          transition: "left 0.3s ease",
          zIndex: 1050,
        }}
      >
        <div
          className="sidebar-content"
          style={{ padding: "20px", color: "#fff", background: "#B24C76" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3 style={{ marginBottom: "20px" }}>Preggy zone</h3>
            <BiX size={32} color="white" onClick={toggleSidebar} />
          </div>
          <hr style={{ marginBottom: "40px" }}></hr>

          <ul className="list-unstyled sideli">
            <li>
              <Link
                className="nav-link active"
                aria-current="page"
                to="/"
                onClick={toggleSidebar}
              >
                <strong> Home</strong>
              </Link>
            </li>
            <li>
              <Link
                className="nav-link active"
                aria-current="page"
                to="/blogs"
                onClick={toggleSidebar}
              >
                <strong>Blogs</strong>
              </Link>
            </li>
            <li>
              <Link
                className="nav-link active"
                aria-current="page"
                to="/help-support"
                onClick={toggleSidebar}
              >
                <strong> Help & Support</strong>
              </Link>
            </li>
            <li>
              <Link
                className="nav-link active"
                aria-current="page"
                to="/faqs"
                onClick={toggleSidebar}
              >
                <strong>FAQ</strong>
              </Link>
            </li>
            <li>
              <Link
                className="nav-link active"
                aria-current="page"
                to="/tools"
                onClick={toggleSidebar}
              >
                <strong>Tools</strong>
              </Link>
            </li>
            <li>
              <Link to="/login">
                <button
                  onClick={toggleSidebar}
                  className="btn  login"
                  style={{
                    border: "1px solid white",
                    color: "white",
                    marginTop: "20px",
                  }}
                >
                  Login / Signup
                </button>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Header;
